import { EventEmitter } from "./event-emitter";

export class ArrayEmitter<T> extends EventEmitter {
	array: T[] = [];
	push(...items: T[]) {
		const rVal = this.array.push(...items);
		this.trigger("change");
		return rVal;
	}

	empty() {
		this.array.length = 0;
		this.trigger("change");
	}

	remove(item: T) {
		const index = this.array.indexOf(item);

		if (index > -1) {
			this.array.splice(index, 1);
			this.trigger("change");
			return true;
		}
		return false;
	}
}
